<div class="stage-activity-wrapper">
  <div class="stage-activity-row">
    <div class="stage-input-area">
      <button
        *ngIf="showPlusButton"
        type="button"
        class="btn p-0 stage-plus-btn border-0"
        (click)="toggleStageDropdown(); $event.stopPropagation()"
        [attr.aria-expanded]="showStageDropdown"
        title="Select stage"
      >
        <i class="fal fa-plus fs-4"></i>
      </button>
      <ng-container *ngIf="selectedStage">
        <span class="stage-tag">
          {{ getStageDisplay(selectedStage) }}
          <button type="button" class="stage-tag-remove" (click)="removeStage()" aria-label="Remove stage">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </span>
        <input
          type="text"
          class="form-control stage-note-input"
          placeholder="Add Note..."
          [(ngModel)]="note"
        />
      </ng-container>
    </div>
    
    <button
        type="button"
        class="btn primary-button gradient send-btn d-flex align-items-center justify-content-center"
        (click)="send()"
        [disabled]="!canSend()"
    >
        <i *ngIf="isSending" class="fa-duotone fa-spinner-third fa-spin"></i>
        <i *ngIf="!isSending" class="fal fa-arrow-up stage-send-icon"></i>
      </button>
  </div>
  <div class="stage-dropdown-container" [class.show]="showStageDropdown" (click)="$event.stopPropagation()">
    <div class="stage-dropdown-header">CHANGE STAGE</div>
    <div class="stage-dropdown-menu">
      <a
        *ngFor="let stage of stages"
        class="stage-dropdown-item"
        (click)="selectStage(stage.value)"
      >{{ stage.display }}</a>
    </div>
  </div>
</div>
